import { render, staticRenderFns } from "./ApplicantResetPassword.vue?vue&type=template&id=65bad0ce&scoped=true&"
import script from "../../services/applicant/applicant-reset-password.js?vue&type=script&lang=js&"
export * from "../../services/applicant/applicant-reset-password.js?vue&type=script&lang=js&"
import style0 from "./ApplicantResetPassword.vue?vue&type=style&index=0&id=65bad0ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bad0ce",
  null
  
)

export default component.exports